import { useShallow } from 'zustand/react/shallow'
import { useAuthStore } from './store'

export const useAuthState = () => useAuthStore(useShallow(({ state }) => state))

export * from './preferences/hooks'
export * from './user/hooks'
